import React, { useContext } from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import { getAiRolePlay } from 'redux/selectors/timeline';
import AiConversationContext from './context';

const ScenarioDetails = () => {
  const { aiRolePlayId } = useContext(AiConversationContext);
  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));

  const { learnerRoleBrief, situationContextBrief, goalsBrief } = aiRolePlay || {};

  return (
    <div className='d-flex flex-column mt-4 align-items-center'>
      <p className='text-large-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.THE_SCENARIO()}</p>
      <div className='mt-4'>
        <div>
          <p className='mb-0 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOUR_ROLE()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>{learnerRoleBrief}</p>
        </div>
        <div>
          <p className='mb-0 mt-4 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.THE_SITUATION()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>{situationContextBrief}</p>
        </div>
        <div>
          <p className='mb-0 mt-4 text-regular bold'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOUR_GOAL()}</p>
          {/* AI ROLE PLAY TODO: replace with AI generated content */}
          <p className='mb-0 text-regular'>{goalsBrief}</p>
        </div>
      </div>
    </div>
  );
};

export default ScenarioDetails;
